import { render, staticRenderFns } from "./openclass-list.vue?vue&type=template&id=34844fc8"
import script from "./openclass-list.vue?vue&type=script&lang=js"
export * from "./openclass-list.vue?vue&type=script&lang=js"
import style0 from "./openclass-list.vue?vue&type=style&index=0&id=34844fc8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports